import { InvoiceProductDetailViewModel } from "@payping/api";

export interface ApplyTaxAndDiscount extends InvoiceProductDetailViewModel {
  totalAmountBeforeTaxAndDiscount?: number;
  totalAmount?: number;
}

export function applyTaxAndDiscount(item: InvoiceProductDetailViewModel): ApplyTaxAndDiscount {
  const tempItem: ApplyTaxAndDiscount = { ...item };
  tempItem.amount = tempItem.amount ? parseFloat(String(tempItem.amount)) : 0;
  tempItem.discountAmount = tempItem.discountAmount ? parseFloat(String(tempItem.discountAmount)) : 0;
  tempItem.quantity = tempItem.quantity || 0;

  if (tempItem.discountAmount) {
    if (tempItem.discountType === 0) {
      // در صورتی که درصد تخیف مساوی بیشتر از 100 بود
      // درصد = 100
      tempItem.discountAmount = tempItem.discountAmount >= 100 ? 100 : tempItem.discountAmount;
      // محاسبه مبلغ تخفیف
      tempItem.discountAmount = Math.round((tempItem.amount * tempItem.discountAmount) / 100);
    } else if (tempItem.discountType === 1) {
      // محاسبه درصد تخفیف
      if (tempItem.discountAmount >= tempItem.amount) {
        // در صورتی که تخیف مساوی بیشتر از مبلغ آیتم بود
        tempItem.discountAmount = tempItem.amount;
      }
    }
  } else {
    tempItem.discountType = 1;
    tempItem.discountAmount = 0;
  }

  tempItem.totalAmount = tempItem.quantity * (tempItem.amount - tempItem.discountAmount);
  tempItem.totalAmountBeforeTaxAndDiscount = tempItem.quantity * tempItem.amount;
  if (tempItem.tax) {
    tempItem.taxRate = 9;
    tempItem.taxtionAmount = Math.round((tempItem.totalAmount * tempItem.taxRate) / 100);
    tempItem.totalAmount += tempItem.taxtionAmount;
  } else {
    tempItem.taxRate = 0;
    tempItem.taxtionAmount = 0;
  }
  return tempItem;
}
